/** Format pledge amount exactly as entered (whole number, no shorthand). */
export function parsePledgeAmountInput(value) {
  const digits = String(value ?? '').replace(/[^\d]/g, '');
  if (digits === '') return null;
  return parseInt(digits, 10);
}

/** Public pledge card — amount only, no currency code. */
export function formatPledgeAmountPlain(amount) {
  const n = Math.round(Number(amount));
  if (!Number.isFinite(n) || n < 0) return '0';
  return n.toLocaleString();
}

export function formatPledgeAmount(amount, currency = 'KES') {
  const n = Math.round(Number(amount));
  const code = String(currency || 'KES').toUpperCase();
  if (!Number.isFinite(n) || n < 0) {
    return code === 'USD' ? '$0' : `${code} 0`;
  }
  if (code === 'USD') return `$${String(n)}`;
  return `${code} ${String(n)}`;
}
